import * as React from 'react'
import { Loading } from 'react-admin'
import { sample } from 'lodash'

const quotes = [
  [
    'Antoine de Saint-Exupery',
    'A designer knows he has achieved perfection not when there is nothing left to add, but when there is nothing left to take away.',
  ],
]
const quote = sample(quotes)
export const AppLoadingView = <Loading loadingPrimary={quote[1]} loadingSecondary={quote[0]} />
